/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { injectable } from 'inversify'
import { SettingsManager } from '../../configuration/SettingsManager'
import { IUserSessionApiClient } from './contracts'
import { ITokenResponse } from '../UserSessionStateManager/contracts'

/**
 * Returns the HardCodedSessionJwt with any call
 *
 * @export
 * @class MockUserSessionApiClient
 * @implements {IUserSessionApiClient}
 */
@injectable()
export class MockUserSessionApiClient implements IUserSessionApiClient {
	tokenResponse: ITokenResponse
	constructor() {
		this.tokenResponse = {
			accessToken: '',
			refreshToken: '',
		} as ITokenResponse
	}
	refreshSessionJwt = (sessionJwt: string | null): Promise<ITokenResponse> =>
		new Promise(resolve => {
			setTimeout(() => {
				resolve(this.tokenResponse)
			}, 100)
		})
}
